import React, { FC } from "react";
import {
  Dialog,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { Close } from "@mui/icons-material";
import { ConciergeHistory } from "types/portfolio";
import moment from "moment";
import ConciergeStatusLabel from "components/app/ConciergeStatusLabel";

const useStyles = makeStyles(() => ({
  wrapper: {
    width: 810,
    padding: 24,
  },
  top: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  titleWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    // fontFamily: "CiscoSansTT",
    fontWeight: 600,
    fontSize: 16,
    color: "#171B1F",
  },
  accountName: {
    // fontFamily: "CiscoSansTT",
    fontSize: 12,
    color: "#898989",
  },
  status: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "3px 5px",
    borderRadius: 4,
  },
  expired: {
    fontSize: 12,
    color: "#B2B2B2",
  },
  point: {
    display: "inline-block",
    width: 4,
    height: 4,
    borderRadius: "50%",
    marginRight: 4,
  },
  statusValue: {
    fontSize: 10,
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  expiredColor: {
    color: "#B2B2B2",
  },
}));

const HistoryPop: FC<{
  open: boolean;
  data: ConciergeHistory[] | undefined;
  accountName: string | undefined;
  handleClose: () => void;
}> = ({ open, data, accountName, handleClose }) => {
  const classes = useStyles();

  const handlePopClose = () => {
    handleClose();
  };

  const StyledTableCell = withStyles(() =>
    createStyles({
      head: {
        backgroundColor: "#DEDEDE",
        color: "#333",
        fontSize: 13,
        fontWeight: "normal",
        borderBottom: "none",
      },
      body: {
        fontSize: 12,
        fontWeight: "normal",
        borderBottom: "none",
        borderRight: "1px solid #EDEDED",
      },
    })
  )(TableCell);

  return (
    <div>
      <Dialog
        onClose={handlePopClose}
        open={open}
        maxWidth="md"
      >
        <div className={classes.wrapper}>
          <div className={classes.top}>
            <div className={classes.titleWrapper}>
              <p className={classes.title}>Concierge</p>
              <p className={classes.accountName}>{accountName}</p>
            </div>
            <IconButton
              onClick={handlePopClose}
              size="large"
            >
              <Close fontSize="small" />
            </IconButton>
          </div>
          <div>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">Status</StyledTableCell>
                    <StyledTableCell align="left">Start Date</StyledTableCell>
                    <StyledTableCell align="left">End Date</StyledTableCell>
                    <StyledTableCell align="left">Funded By</StyledTableCell>
                    <StyledTableCell align="left">Last Update</StyledTableCell>
                    <StyledTableCell align="left">Last Updated By</StyledTableCell>
                    <StyledTableCell align="left">Created By</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.map((item) => (
                    <TableRow key={item.id}>
                      <StyledTableCell align="left">
                        <ConciergeStatusLabel type={(item?.status as any) ?? "No"} />
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        className={`${item.status !== "Active" ? classes.expiredColor : ""}`}
                      >
                        {item.effectiveFrom
                          ? moment(item?.effectiveFrom).format("MM/DD/YYYY")
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        className={`${item.status !== "Active" ? classes.expiredColor : ""}`}
                      >
                        {item.effectiveTo ? moment(item?.effectiveTo).format("MM/DD/YYYY") : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        className={`${item.status !== "Active" ? classes.expiredColor : ""}`}
                      >
                        {item.funded ?? "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        className={`${item.status !== "Active" ? classes.expiredColor : ""}`}
                      >
                        {item.lastModifiedDate
                          ? moment(item.lastModifiedDate).format("MM/DD/YYYY")
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        className={`${item.status !== "Active" ? classes.expiredColor : ""}`}
                      >
                        {item.modifierName ?? "N/A"}
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        className={`${item.status !== "Active" ? classes.expiredColor : ""}`}
                      >
                        {item.creatorName ?? "N/A"}
                      </StyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default HistoryPop;
